import { useState } from 'react';
import { API_URL } from '@constants';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';

const ENDPOINT_URL = '/spaces/property-types';

export interface PropertyType {
    key: string;
    value: string;
}

export interface GetPropertyTypesSuccessResponse {
    status: number;
    success: boolean;
    message: string;
    data: PropertyType[];
    links: Record<string, unknown>;
}

/**
 * Requests endpoint to get all property types (space type categories).
 */
export const useGetPropertyTypes = () => {
    const { getHeaders, handleCommonErrors } = useApiConfig();
    const [propertyTypes, setPropertyTypes] = useState<GetPropertyTypesSuccessResponse['data']>([]);
    const [loading, setLoading] = useState<boolean>(false);

    const request = async () => {
        setLoading(true);

        try {
            const response = await fetch(`${API_URL}${ENDPOINT_URL}`, {
                method: 'GET',
                headers: getHeaders(),
            });

            if (!response.ok) {
                const json = await response.json();
                const error = new Error(json.error || '') as ApiError;
                error.statusCode = response.status;
                throw error;
            }

            const data: GetPropertyTypesSuccessResponse = await response.json();

            setPropertyTypes(data.data);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err: any) {
            handleCommonErrors(err);
        } finally {
            setLoading(false);
        }
    };

    return { request, propertyTypes, loading };
};
